<template>
  <section class="learnings">
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="10" md="8" lg="6">
          <h2 class="learnings__title title-1">Keep up with XD to Flutter</h2>
          <p class="learnings__subtitle body-2">
            We share the latest developments, techniques, tips, tricks, and learnings at
            <a
              href="https://blog.gskinner.com"
              target="_blank"
              rel="noreferrer"
              class="learnings__subtitle__link"
              aria-label="visit gskinner blog in a new tab"
            >
              blog.gskinner.com
            </a>.
          </p>

          <div class="announcements">
            <article
              v-for="item in blogPosts"
              :key="item.title"
              class="announcement"
            >
              <a class="announcement__title announcement__title--darker" :href="item.link" target="_blank" rel="noreferrer" :aria-label="`visit ${item.title} in a new tab`">
                {{ item.title }}
              </a>
              <p class="announcement__description body-3">
                {{ item.description }}
              </p>
            </article>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
    name: "Learnings",
    data: () => ({
      blogPosts: [
        {
          title: "XD to Flutter v3.0",
          description: "Announcement",
          link:
            "https://blog.gskinner.com/archives/2021/08/xd-to-flutter-v3-0.html",
        },
        {
          title: "Export Responsive Layouts for Flutter with Adobe XD",
          description: "How-to",
          link:
            "https://blog.gskinner.com/archives/2020/08/export-responsive-layouts-for-flutter-with-adobe-xd.html",
        },
        {
          title: "Announcing XD to Flutter v2.0!",
          description: "Announcement",
          link:
            "https://medium.com/flutter/announcing-xd-to-flutter-v2-0-c743bac2aeeb",
        },
      ],
    }),
  };
</script>

<style scoped lang="scss">
  @import "../variables";

  .learnings {
    margin-bottom: pxToRem(96);

    &__title {
      color: $title;
      margin-bottom: pxToRem(8);
    }

    &__subtitle {
      color: $body-3;
      margin-bottom: pxToRem(24);
      &__link {
        color: #0051FF;
      }
    }

    .announcements {
      .announcement {
        margin-bottom: pxToRem(32);

        &__title {
          color: $accent;
          font-weight: 600;
          margin-bottom: pxToRem(8);
          font-size: 23px;
          line-height: 35px;

          @media (min-width: 768px) {
            font-size: 18px;
            line-height: 28px;
          }
          &--darker {
            color: #336AD8;
          }
        }

        &__description {
          color: $body-3;
        }
      }
    }
  }
</style>
